<template>
  <b-form-group
    label="アイコン画像"
  >
    <img
      v-show="image"
      class="preview"
      :src="image"
    >

    <b-form-file
      v-model="file"
      @change="change"
      placeholder="画像を選択"
      drop-placeholder="画像をドロップ"
      browse-text="選択"
    ></b-form-file>
  </b-form-group>
</template>

<script>
export default {
  data () {
    return {
      modelName: 'settings/userInfo',
      attribute: 'imageBlob',
      image: null,
      file: null
    }
  },

  computed: {
    model: {
      get () {
        return this.$store.getters[`${this.modelName}/getAttr`](this.attribute)
      },

      set (value) {
        this.$store.commit(`${this.modelName}/setAttr`, {
          name: this.attribute,
          value
        })
      }
    }
  },

  methods: {
    change (e) {
      const files = e.target.files || e.dataTransfer.files
      this.createImage(files[0])
    },

    createImage (file) {
      const reader = new FileReader()
      reader.onload = e => {
        this.image = e.target.result
        this.model = this.image
        this.$store.commit(`${this.modelName}/setAttr`, {
          name: 'imageName',
          value: file.name
        })
      }
      reader.readAsDataURL(file)
    }
  }
}
</script>

<style lang="scss" scoped>
.preview {
  max-width: 180px;
  max-height: 180px;
}
</style>
